import React from "react";
import { Link } from "react-router-dom";
import Banner from "../../images/banner.jpg";
import "./NotFound.css";
import Footer from "../Footer/Footer";

const NotFound = () => {
  return (
    <div className="forbidden-container">
      <div className="shop-banner">
        <img src={Banner} alt="Shop Banner" />
      </div>
      <h1>404</h1>
      <h2>Page Not Found</h2>
      <p>The page you’re looking for doesn’t exist.</p>

      <Link to="/" className="forbidden-home">
        Go Back Home
      </Link>

      <Footer />
    </div>
  );
};

export default NotFound;
